import usePaginationParams from 'app/hooks/usePaginationParams';
import DockerImages from 'components/Dashboard/Models/DockerImages/DockerImages';
import NamedModels from 'components/Dashboard/Models/NamedModels/NamedModels';
import { DashboardPageProps } from 'components/Dashboard/types';

import React from 'react';
import { Tabs, TabsProps } from 'antd';

const Models: React.FC<DashboardPageProps> = ({ setTitle }) => {
  const { clearFilters } = usePaginationParams();

  const tabs: TabsProps['items'] = [
    {
      destroyInactiveTabPane: true,
      key: 'docker_images',
      label: 'Docker images',
      children: <DockerImages setTitle={setTitle} />,
    },
    {
      destroyInactiveTabPane: true,
      key: 'named_models',
      label: 'Named models',
      children: <NamedModels setTitle={setTitle} />,
    },
  ];

  return <Tabs onChange={clearFilters} defaultActiveKey="docker_images" items={tabs} destroyInactiveTabPane />;
};

export default Models;
